class Role {
    id!: number
    name!: string

    constructor(role: Role) {
        Object.assign(this, role)
    }
}

export default Role